// extracted by css-extract-rspack-plugin
export default {"optionsRoot":"vKf44","educationalButton":"y124V"};